import Vue from 'vue'
import Router from 'vue-router'
import Axios from 'axios'
import 'vant/lib/index.css';
import axiosTripartite from '../api/axiosTripartite.js'
import store from '../main.js'
import Toast from 'vant/lib/toast';
import 'vant/lib/toast/style';
import { shopRoutes } from '@/router/shop'

Vue.use(Router)


const router = new Router({
  mode: "hash", //history
  base: '/dist/', // __dirname
  routes: [{
    path: "/",
    component: resolve => require(["../App.vue"], resolve),
    children: [{
      path: "/",
      component: resolve => require(["../view/index.vue"], resolve),
      meta: {
        requireAuth: false,
        keepAlive: false
      }
    }, {
      path: "/mine",
      component: resolve => require(["../view/mine/index.vue"], resolve),
      meta: {
        requireAuth: true,
        keepAlive: false
      }
    }
    ],
    meta: {
      requireAuth: false
    }
  }, {
    //更多--列表
    path: "/more",
    component: resolve => require(["../view/more.vue"], resolve),
    meta: {
      requireAuth: false,
      keepAlive: false
    }
  }, {
    //权益详情
    path: "/details",
    component: resolve => require(["../view/details/index.vue"], resolve),
    meta: {
      requireAuth: false,
      keepAlive: false
    }
  }, {
    //权益详情
    path: "/detailsCombo",
    component: resolve => require(["../view/details/combo.vue"], resolve),
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    //领取记录
    path: "/order",
    component: resolve => require(["../view/mine/order.vue"], resolve),
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    //券码详情
    path: "/orderDetails",
    component: resolve => require(["../view/mine/orderDetails.vue"], resolve),
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    //订购列表
    path: "/vip",
    component: resolve => require(["../view/mine/vip.vue"], resolve),
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    path: "/handle",
    component: resolve => require(["../view/handle/index.vue"], resolve),
    meta: {
      requireAuth: true,
      keepAlive: false
    }
  }, {
    path: "/signin",
    component: resolve => require(["../view/signin.vue"], resolve),
    meta: {
      requireAuth: false,
      keepAlive: false
    }
  },
  {
    // 公告list
    path: "/gglist",
    component: resolve => require(["../view/gglist.vue"], resolve),
    meta: {
      requireAuth: false,
      keepAlive: false
    }
  },
  {
    // 公告详情
    path: "/ggdetail",
    component: resolve => require(["../view/ggdetail.vue"], resolve),
    meta: {
      requireAuth: false,
      keepAlive: false
    }
  }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})
// shopRoutes.forEach(function(route){
//   router.addRoute(route)
// });
export default router

// Djyz999888DJYZ   yiqunchougongyi
function getUrlParam(name) {//封装方法
  if (!name) return null;
  // 查询参数：先通过search取值，如果取不到就通过hash来取
  var after = window.location.search;
  after = after.substr(1) || window.location.hash.split('?')[1];
  // 地址栏URL没有查询参数，返回空
  if (!after) return null;
  // 如果查询参数中没有"name"，返回空
  if (after.indexOf(name) === -1) return null;
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  // 当地址栏参数存在中文时，需要解码，不然会乱码
  var r = decodeURI(after).match(reg);
  // 如果url中"name"没有值，返回空
  if (!r) return null;
  return r[2];
}
function isWeixn() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}
function getIndex(to,fn){
  let setmealIndex = sessionStorage.getItem('setmealIndex')
  if ((!to.query || to.query.setmealIndex === undefined) && setmealIndex !== null && to.path !== '/signIn'){
    fn({
      path:to.path,
      query:{setmealIndex:setmealIndex}
    })
  }else {
    fn()
  }
}
function removeURLParameter(url, parameter) {
  var urlparts = url.split('?');
  if(urlparts.length >= 2) {
    //参数名前缀
    var prefix = encodeURIComponent(parameter) + '=';
    var pars = urlparts[1].split(/[&;]/g);

    //循环查找匹配参数
    for(var i = pars.length; i-- > 0;) {
      if(pars[i].lastIndexOf(prefix, 0) !== -1) {
        //存在则删除
        pars.splice(i, 1);
      }
    }

    return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
  }
  return url;
}
function removeCodeParam(url) {
	let regex = /(\?|&)(code=[^&#]*)/g // 匹配 ? 或 & 后面跟着 code=xxx 的部分
	return url.replace(regex, '')
}
router.beforeEach((to, from, next) => {
  let token = getUrlParam('token')
  if (token){
    sessionStorage.setItem('tykj-token',token)
    axiosTripartite.post(1,'/user/getUserInfo',{token:token},res=>{
      let userinfo = res.data.data.userinfo
      sessionStorage.setItem('tykj-openId',userinfo.mandate.openid)
      store.state.userinfo = userinfo;
      let newurl = removeURLParameter(window.location.href,'token')
      if (newurl){
        window.location.href = newurl;
        location.reload()
        return
      }
    })
  }else if (sessionStorage.getItem('tykj-token')) {
    // 判断是否微信环境
    if (isWeixn()) {
      // 判断是否已授权
      console.log(sessionStorage.getItem('tykj-openId'))
      if (sessionStorage.getItem('tykj-openId')) {
        getIndex(to,next)
      } else {
        // 判断是否授权过
        if (!sessionStorage.getItem('tykj-code-msg')) {
          // 进行微信授权
          const code = getUrlParam('code')
          const local = window.location.href.replace('#', '%23');
          if (code == null || code == "") {
            window.location.href = 'http://tlhk.xinquanyu.top/empower_tlhk.html?url=' + local
          } else {
            let formData = new FormData();
            formData.append("platform", 'wechat');
            formData.append("code", code);
            formData.append("token", sessionStorage.getItem("tykj-token"));
            axiosTripartite.post(1, "/user/third", formData, (res) => {
              if (res.data.code == 0) {
                if (res.data.msg != "操作失败") {
                  Toast({
                    message:res.data.msg,
                    duration:3000
                  })
                  sessionStorage.setItem("tykj-code-msg", res.data.msg)
                } else {
                  window.location.href = 'http://tlhk.xinquanyu.top/empower_tlhk.html?url=' + removeCodeParam(window.location.href)
                }
              } else {
                let mandate = res.data.data.userinfo.mandate;
                if (mandate) {
                  sessionStorage.setItem("tykj-openId", mandate.openid);
                }
              }
            })
            getIndex(to,next)
          }
        } else {
          getIndex(to,next)
        }
      }
    } else {
      getIndex(to,next)
    }
  }
  if (to.matched.some(res => res.meta.requireAuth)) {
    if (sessionStorage.getItem('tykj-token')) { // 判断是否登录
      next()
    } else { // 没登录则跳转到登录界面
      router.push({
        path: '/signIn',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    getIndex(to,next)
  }
  let pathTit = ''
  if (to.path === '/') {
    pathTit = '· home'
  } else {
    pathTit = to.path.replaceAll('/', ' · ')
  }
  document.title = `权益包 ${pathTit}`
})
new Vue({
  router,
  template: `
		<router-view></router-view>
		`
}).$mount("#app")



// WEBPACK FOOTER //
// ./src/router/index.js